import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = ($scope, $stateParams, $translate, PolicyChangeService, $q, ModalService) => {
    const ctrl = Object.create(BaseCtrl);

    $scope.documentMetaDataTemplate = {
        docUID: '001',
        documentType: 'letter_received',
        securityType: 'unrestricted',
        status: 'approved',
        jobNumber: $stateParams.policyChangeNumber
    };

    $scope.documents = [];
    $translate('gateway.directives.gateway-documents.There are no documents associated with this policy change').then((msg) => {
        $scope.noDocumentsMessage = msg;
    });

    ctrl.getDocuments = () => {
        $scope.gettingDocumentsPromise = PolicyChangeService.getDocumentsForPolicyChange($stateParams.policyChangeNumber).then(
            (documents) => {
                $scope.documents = documents;
            },
            () => {
                ModalService.showError('gateway.views.modal.Error', 'gateway.views.quote-documents.Error loading documents');
            }
        );
    };

    ctrl.getDocuments();

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$translate', 'PolicyChangeService', '$q', 'ModalService'];

export default fn;